import { render, staticRenderFns } from "./CD-Risk10.vue?vue&type=template&id=3a6b87f2&scoped=true&lang=pug&"
import script from "./CD-Risk10.vue?vue&type=script&lang=ts&"
export * from "./CD-Risk10.vue?vue&type=script&lang=ts&"
import style0 from "./CD-Risk10.vue?vue&type=style&index=0&id=3a6b87f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b87f2",
  null
  
)

export default component.exports